import type { ReactNode } from "react";

export enum LabelSize {
  SM = "SM",
  BASE = "BASE"
}

export interface LabelProps {
  children?: string | ReactNode;

  /**
   * `label` (default) for inputs, `legend` for fieldsets/radio groups,
   * `span` when the label is already wrapped by a `<label>` element.
   */
  as?: "label" | "legend" | "span";
  htmlFor?: string;
  id?: string;
  className?: string;

  size?: LabelSize;
  /** Paints the label with the danger token (used by grouped fields). */
  error?: boolean;

  /** Renders a trailing `*` after the label text. */
  showRequired?: boolean;
  /** Renders a trailing `(optional)` suffix after the label text. */
  showOptional?: boolean;
  /** Overrides the optional suffix copy. Wins over `locale`. */
  optionalText?: string;
  /** Locale for the built-in optional copy. Supports `en` and `es`. */
  locale?: string;
}
